import EmpresaMapper from "@/common/contabil/EmpresaMapperAdapter";
import { IDataSourceDetalhesTributosRetidos } from "@/views/contabil/dashboardTributacao/widgets/TributosRetidos/detalhes/types";
import { IEmpresaResponse } from "../../shared/requests/types";

export interface IDetalhesTributosRetidosParams {
  empresasId?: string[];
  ano: number;
}

export interface IDetalhesTributosRetidosTotalTributoResponse {
  totalRendimento?: number;
  totalIrrf?: number;
  totalCsrf?: number;
  totalCsrfPisRetido?: number;
  totalCsrfCofinsRetido?: number;
}

export interface IDetalhesTributosRetidosTotalDctfResponse {
  efdTotalIrrf?: number;
  efdTotalCsrf?: number;
  efdTotalPisRetido?: number;
}

export interface IDetalhesTributosRetidosDiferencaResponse {
  diferencaIrrf?: number;
  diferencaCsrf?: number;
  diferencasPisRetido?: number;
  diferencaCofinsRetido?: number;
}

export interface IDetalhesTributosRetidosTributoResponse {
  ano: number;
  estabelecimento?: string;
  cnpjCpfFontePagadora?: string;
  nomeFontePagadora?: string;
  codigoTributo?: string;
  rendimento?: number;
  irrf?: number;
  csrf?: number;
  pisRetido?: number;
  cofinsRetido?: number;
}

export interface IDetalhesTributosRetidosResponse extends IEmpresaResponse {
  totalTributo: IDetalhesTributosRetidosTotalTributoResponse;
  diferenca: IDetalhesTributosRetidosDiferencaResponse;
  totalDctf: IDetalhesTributosRetidosTotalDctfResponse;
  tributos: IDetalhesTributosRetidosTributoResponse[];
}

export default class DetalhesTributosRetidos {
  constructor(
    readonly response: IDetalhesTributosRetidosResponse[] | undefined
  ) {}

  hasData() {
    return this.response?.length !== 0;
  }

  handleGetEmpresa(tributo: IDetalhesTributosRetidosResponse) {
    return `${tributo.cnpj?.completo} - ${tributo.nomeFantasia}` || "-";
  }

  handleTableData(cnpj: string | null): IDataSourceDetalhesTributosRetidos[] {
    const empresa = this.response?.find(
      (empresa) => empresa.cnpj?.completo === cnpj
    );

    if (!empresa) return [];

    return empresa.tributos.map((tributo) => ({
      empresa: EmpresaMapper.toEntity(empresa),
      cnpjFontePagadora: tributo.cnpjCpfFontePagadora || "-",
      codigo: tributo.codigoTributo || "-",
      cofins: tributo.cofinsRetido?.toString() || "-",
      csrf: tributo.csrf?.toString() || "-",
      irrf: tributo.irrf?.toString() || "-",
      matriz: tributo.estabelecimento || "-",
      nomeFontePagadora: tributo.nomeFontePagadora?.toString() || "0",
      pis: tributo.pisRetido?.toString() || "-",
      rendimento: tributo.rendimento?.toString() || "-"
    }));
  }

  getFirstCNPJ() {
    return this.response?.at(0)?.cnpj?.completo || "-";
  }
}
